/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902116895 — API-контракт лояльності */

import { apiClient } from '../../../shared/lib/apiClient';
import { LoyaltyState } from '../hooks';
import { LOYALTY_ENDPOINTS } from './loyalty.api-constants';
import {
    GetLoyaltyBalanceRequestDto,
    GetLoyaltyBalanceResponse,
    GetLoyaltyConfigResponse,
    GetLoyaltyRewardResponse,
} from './loyalty.api-types';

export async function getUserLoyaltyBalance(
    loyaltyBalanceDto: GetLoyaltyBalanceRequestDto,
) {
    const { userId, vmId } = loyaltyBalanceDto;
    const response = await apiClient.get<GetLoyaltyBalanceResponse>(
        LOYALTY_ENDPOINTS.BALANCE,
        { params: { userId, vmId } },
    );

    return response.data;
}

export async function getLoyaltyConfigDetails(loyaltyConfigId: number) {
    const response = await apiClient.get<GetLoyaltyConfigResponse>(
        LOYALTY_ENDPOINTS.CONFIG_DETAILS,
        { params: { loyaltyConfigId } },
    );

    return response.data;
}

export async function getLoyaltyRewardDetails(loyaltyRewardId: number) {
    const response = await apiClient.get<GetLoyaltyRewardResponse>(
        LOYALTY_ENDPOINTS.REWARD_DETAILS,
        { params: { loyaltyRewardId } },
    );

    return response.data;
}

export async function getLoyaltyDetails(
    loyaltyBalanceDto: GetLoyaltyBalanceRequestDto,
): Promise<Partial<LoyaltyState>> {
    const {
        balance,
        loyalty_config_id,
        loyalty_id,
        loyalty_reward_id,
        loyalty_user_id,
    } = await getUserLoyaltyBalance(loyaltyBalanceDto);

    const resultState: Partial<LoyaltyState> = {
        currentBalance: balance,
        loyalty_id,
        loyalty_config_id,
        loyalty_reward_id,
        loyalty_user_id,
    };

    if (!loyalty_config_id || !loyalty_reward_id) {
        return resultState;
    }

    // Get Loyalty Config Details
    const { min_price_participate, game_enabled } =
        await getLoyaltyConfigDetails(loyalty_config_id);

    // Get Loyalty Reward Details
    const { loyalty_cost, points } =
        await getLoyaltyRewardDetails(loyalty_reward_id);

    return {
        ...resultState,
        productMinPriceToGetBonusPoints: min_price_participate,
        pointsToGetLoyaltyReward: loyalty_cost,
        pointsToShowLoyaltyBonus: points,
        isGameEnabled: Boolean(game_enabled),
    };
}
